document.addEventListener("DOMContentLoaded", () => {

    // u projektu a nemovitosti autoskroll
    // =============

    (() => {
        const header = document.querySelector("[data-sticky-header]");
        const body = document.querySelector("body");
        const scrollelement = document.querySelector("[data-brokerinfo-autoscroll]");

        if ((typeof(header) != 'undefined' && header != null) && (typeof(scrollelement) != 'undefined' && scrollelement != null)){

            const scrollelementOffsetTop =  scrollelement.getBoundingClientRect().top + window.pageYOffset + 200;
            scrollelement.style.transition = "all 0.6s";

            const headerOffset = header.offsetTop - window.scrollY;
            let lastScroll = 0;

            const hidingOnScroll = () => {
                const currentScroll = window.pageYOffset;

                if (currentScroll > headerOffset) {

                    body.classList[currentScroll < lastScroll && currentScroll > scrollelementOffsetTop ? 'add' : 'remove']('stickyheader-brokerinfoslidedown');

                    if(currentScroll < lastScroll && currentScroll > scrollelementOffsetTop){
                        scrollelement.style.transform = "translateY("+header.offsetHeight+"px)";
                    }else{
                        scrollelement.style.transform = "translateY(0px)";
                    }
                }
                lastScroll = currentScroll;
            }

            hidingOnScroll();
            window.addEventListener('scroll', () => hidingOnScroll(), {passive: true});

        }

    })();



});